import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import wardApi from 'api/wardApi'

export const thunkWard = createAsyncThunk(
  'ward/getAll',
  async (param, thunkApi) => {
    try {
      const res = await wardApi.getAll(param)
      return res // Trả về dữ liệu API trả về
    } catch (error) {
      return thunkApi.rejectWithValue(error) // Xử lý lỗi
    }
  },
)
const reportSlice = createSlice({
  name: 'ward',
  initialState: {
    processes: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(thunkWard.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(thunkWard.fulfilled, (state, action) => {
        state.loading = false
        state.processes = action.payload // Cập nhật state với dữ liệu trả về
      })
  },
})

const { reducer } = reportSlice
export default reducer
